import { render, staticRenderFns } from "./ZKDPDF.vue?vue&type=template&id=6c207bee&scoped=true&"
import script from "./ZKDPDF.vue?vue&type=script&lang=ts&"
export * from "./ZKDPDF.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c207bee",
  null
  
)

export default component.exports